import { Route, Routes } from 'react-router';
import NotFoundPage from '../NotFound.page';
import { FiscalRepRoutes } from './fiscal-rep';
import NifOrderRoutes from './nif';

function OrderRoutes(): JSX.Element {
  return (
    <Routes>
      <Route path="nif/*" element={<NifOrderRoutes />} />
      <Route path="fiscal-rep/*" element={<FiscalRepRoutes />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default OrderRoutes;
